<template>
  <div class="login-register" center style="z-index: 9999" v-show="boxVisible">
    <el-dialog :visible.sync="showWeixin" width="620px">
      <div slot="title">
        <div class="rect"></div>
        <div
          class="dialog-title  "
          style="background: #F5F5F5;
border-radius: 6px 6px 0px 0px;font-size: 24px;
font-family: MicrosoftYaHei;
color: #262626;"
        >
          登录微信
        </div>
      </div>
      <div>
        <div
          class="weixin-qrcode"
          style="
            width: 200px;

            margin: 35px auto;
            position: relative;
            margin-top:0px;
          "
        >
          <!-- <img :src="qrcodeUrl" v-if="qrcodeUrl != ''"> -->
          <canvas id="canvas" style="border:solid 1px #c7c7c7;"></canvas>
          <div
            style="width: 198px;height: 48px;background: rgb(226, 49, 48);margin:0 auto;display: flex;justify-content: space-between;color: #fff; padding: 10px 15px;box-sizing: border-box;align-items: center;margin-top:10px;"
          >
            <img style="width:24px;height:24px;" src="/static/img/sm.png" />
            <p
              style="color:#fff;font-size: 13px;line-height:17px;width:104px;text-align:left;"
            >
              {{ qrcodeTips }}
            </p>
          </div>
          <!-- <div
            v-show="refresh_qrcode"
            style="
              position: absolute;
              background: rgba(255, 255, 255, 0.8);
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              text-align: center;
            "
          >
            <div
              style="
                width: 55px;
                height: 55px;
                background: #fff;
                border-radius: 27.5px;
                line-height: 55px;
                text-align: center;
                box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
              "
              class="xy-middle"
            >
              <span
                class="iconfont iconshuaxin"
                style="font-size: 26px"
                @click="wexinLogin"
              ></span>
            </div>
          </div> -->
        </div>
        <!-- <div
          style="
            width: 250px;
            height: 52px;
            line-height: 52px;
            background: #f2f2f2;
            color: #646464;
            margin: 0px auto;
            text-align: center;
            border-radius: 26px;
          "
          v-html="qrcodeTips"
        ></div> -->
      </div>
    </el-dialog>
    <div class="app-container">
      <div
        class="swiperTitle"
        style="    display: flex;
    justify-content: space-between;
    align-items: center;"
      >
        <div>
          <span @click="slide(0)" :class="activeShow === 0 ? 'active' : ''"
            >登录</span
          ><span
            v-show="$store.state.webInfo.register_status == 1"
            :class="activeShow === 1 ? 'active' : ''"
            @click="slide(1)"
            >注册</span
          >
        </div>
        <div
          style="float: right;text-align: right;display: flex;align-items: center;    cursor: pointer;"
          v-if="isShwoLogin"
          @click="wexinLogin"
        >
          <img
            style="width:35px;margin-right:7px;"
            alt="微信登录"
            src="/static/img/wx.png"
          /><span
            style="margin-right:0px;height: 16px;
font-size: 12px;
font-family: MicrosoftYaHei;
color: #989898;
line-height: 16px;"
            >微信登录</span
          >
        </div>
      </div>
      <div class="swiper">
        <swiper
          ref="mySwiper"
          class="swiper-no-swiping"
          :options="swiperOptions"
        >
          <swiper-slide>
            <el-form
              :model="accountForm"
              :rules="accountFormRules"
              ref="accountForm"
              label-width="0px"
              class="demo-ruleForm loginform"
              v-show="loginShow"
            >
              <!--   @focus="onInputFocus()"
                  @blur="blur(accountForm.name, 0)" -->
              <el-form-item prop="name" ref="loginName">
                <el-input
                  name="loginName"
                  id="loginName"
                  class="input-css"
                  v-model="accountForm.name"
                  @focus="accountForm.activeclass1 = true"
                ></el-input>
                <label
                  class="lableInput"
                  :class="
                    accountForm.activeclass1 === true ? 'lableInput1' : ''
                  "
                  for="loginName"
                  >请输入账号/用户名/编号</label
                >
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  class="input-css"
                  id="loginPass"
                  name="loginPass"
                  auto-complete="new-password"
                  v-model="accountForm.password"
                  :type="viewPassword(accountForm.isShowPassword)"
                  @focus="accountForm.activeclass2 = true"
                  @blur="blur(accountForm.password, 1)"
                >
                  <i
                    class="iconfont"
                    :class="{
                      iconyanjing1: accountForm.isShowPassword,
                      iconyanjing: !accountForm.isShowPassword
                    }"
                    slot="suffix"
                    style="line-height: 60px"
                    @click="
                      accountForm.isShowPassword = !accountForm.isShowPassword
                    "
                  ></i>
                </el-input>
                <label
                  class="lableInput"
                  :class="
                    accountForm.activeclass2 === true ? 'lableInput1' : ''
                  "
                  for="loginPass"
                  >密码</label
                >
              </el-form-item>
              <el-form-item
                prop="qrcode"
                style="flex-direction: row; margin-bottom: 30px"
              >
                <el-input
                  class="input-css"
                  id="loginCode"
                  name="loginCode"
                  v-model="accountForm.qrcode"
                  style=""
                  @focus="accountForm.activeclass3 = true"
                  @blur="blur(accountForm.qrcode, 2)"
                ></el-input>
                <label
                  class="lableInput"
                  :class="
                    accountForm.activeclass3 === true ? 'lableInput1' : ''
                  "
                  for="loginCode"
                  >验证码</label
                >
                <div class="qrcode-img" @click="refreshCode">
                  <s-identify :identifyCode="identifyCode"></s-identify>
                </div>
              </el-form-item>
              <el-form-item style="margin-top: 15px; margin-bottom: 10px">
                <!--  :disabled="passtijiao" -->
                <el-button
                  type="primary"
                  @click="submitnvc('accountForm', 1)"
                  style=""
                  class="g-bottom"
                  >立即登录</el-button
                >
              </el-form-item>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                  height: 50px;
                "
              >
                <router-link :to="{ name: 'FindPassword' }">
                  <div
                    style="
                      float: left;
                      display: inline-block;
                      height: 19px;
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #4478d6;
                      line-height: 19px;
                    "
                  >
                    忘记密码？
                  </div>
                </router-link>
                <div @click="loginShow = false">
                  <span
                    style="
                      height: 19px;
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #4478d6;
                      line-height: 19px;
                    "
                    >手机短信登录
                  </span>
                </div>
                <!-- <div
                  v-show="$store.state.webInfo.register_status == 1"
                  style="float: right; display: inline-block; cursor: pointer"
                  @click="changeVisible"
                >
                  立即注册
                </div> -->
              </div>
            </el-form>
            <el-form
              :model="phoneForm"
              :rules="phoneFormRules"
              ref="phoneForm"
              label-width="0px"
              class="demo-ruleForm"
              v-show="!loginShow"
            >
              <el-form-item prop="phone">
                <el-input
                  class="input-css"
                  id="loginPhone"
                  v-model="phoneForm.phone"
                  @focus="phoneForm.activeclass1 = true"
                ></el-input>
                <label
                  class="lableInput"
                  :class="phoneForm.activeclass1 === true ? 'lableInput1' : ''"
                  for="loginPhone"
                  >请输入手机号码</label
                >
              </el-form-item>
              <el-form-item prop="qrcode">
                <el-input
                  class="input-css"
                  id="loginPhoneQode"
                  v-model="phoneForm.qrcode"
                  @focus="phoneForm.activeclass2 = true"
                  @blur="blur(phoneForm.activeclass2, 2)"
                  style=""
                ></el-input>
                <label
                  class="lableInput"
                  :class="phoneForm.activeclass2 === true ? 'lableInput1' : ''"
                  for="loginPhoneQode"
                  >验证码</label
                >
                <el-button
                  class="phonecode"
                  @click="submitnvc('phoneForm', 2)"
                  :loading="codeLoading"
                  >获取验证码</el-button
                >
              </el-form-item>
              <el-form-item style="margin-bottom: 10px; padding-top: 15px">
                <el-button
                  type="primary"
                  class="g-bottom"
                  style="
                    height: 48px;
                    border-radius: 6px;
                  "
                  @click="phonelogin('phoneForm')"
                  >立即登录</el-button
                >
              </el-form-item>
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  width: 100%;
                  height: 50px;
                "
                v-if="isShwoLogin"
              >
                <div @click="loginShow = true">
                  <span
                    style="
                      height: 19px;
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #4478d6;
                      line-height: 19px;
                    "
                    >账号密码登录</span
                  >
                </div>
              </div>
            </el-form>
          </swiper-slide>
          <swiper-slide>
            <el-form
              :model="registerForm"
              :rules="registerFormRules"
              ref="registerForm"
              label-width="0px"
              class="demo-ruleForm"
            >
              <el-form-item prop="phone">
                <el-input
                  class="input-css"
                  v-model="registerForm.phone"
                  id="registerPhone"
                  @focus="registerForm.activeclass1 = true"
                  @blur="blur(registerForm.activeclass1, 1)"
                ></el-input>
                <label
                  class="lableInput"
                  :class="
                    registerForm.activeclass1 === true ? 'lableInput1' : ''
                  "
                  for="registerPhone"
                  >请输入手机号码</label
                >
              </el-form-item>
              <el-form-item prop="qrcode">
                <el-input
                  class="input-css"
                  v-model="registerForm.qrcode"
                  id="registePhoneQode"
                  @focus="registerForm.activeclass2 = true"
                ></el-input>
                <el-button
                  class="loginCode"
                  :loading="codeLoadingreg"
                  @click="submitnvc('registerForm', 3)"
                  >获取验证码</el-button
                >
                <label
                  class="lableInput"
                  :class="
                    registerForm.activeclass2 === true ? 'lableInput1' : ''
                  "
                  for="registePhoneQode"
                  >请输入验证吗</label
                >
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  class="input-css"
                  id="registePass"
                  auto-complete="new-password"
                  v-model="registerForm.password"
                  :type="viewPassword(registerForm.isShowPassword)"
                  @focus="registerForm.activeclass3 = true"
                >
                  <i
                    class="iconfont"
                    :class="{
                      iconyanjing1: registerForm.isShowPassword,
                      iconyanjing: !registerForm.isShowPassword
                    }"
                    slot="suffix"
                    style="height: 60px; line-height: 60px"
                    @click="
                      registerForm.isShowPassword = !registerForm.isShowPassword
                    "
                  ></i>
                </el-input>
                <label
                  class="lableInput"
                  :class="
                    registerForm.activeclass3 === true ? 'lableInput1' : ''
                  "
                  for="registePass"
                  >输入密码</label
                >
              </el-form-item>
              <el-form-item prop="rePassword">
                <el-input
                  class="input-css"
                  id="reRegistePass"
                  auto-complete="new-password"
                  v-model="registerForm.rePassword"
                  :type="viewPassword(registerForm.isShowPassword)"
                  @focus="registerForm.activeclass4 = true"
                >
                  <i
                    class="iconfont"
                    :class="{
                      iconyanjing1: registerForm.isShowPassword,
                      iconyanjing: !registerForm.isShowPassword
                    }"
                    slot="suffix"
                    style="height: 60px; line-height: 60px"
                    @click="
                      registerForm.isShowPassword = !registerForm.isShowPassword
                    "
                  ></i>
                </el-input>
                <label
                  class="lableInput"
                  :class="
                    registerForm.activeclass4 === true ? 'lableInput1' : ''
                  "
                  for="reRegistePass"
                  >确认密码</label
                >
              </el-form-item>
              <el-form-item style="margin-bottom: 0px; padding-top: 15px">
                <el-button
                  type="primary"
                  style="
                    height: 48px;
                    background: #e23130;
                    border-radius: 6px;
                    border: 1px solid #e23130;
                  "
                  @click="RegisterNow('registerForm')"
                  >立即注册</el-button
                >
              </el-form-item>
            </el-form>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>

<script>
import Nvc from "./nvc";
var QRCode = require("qrcode");
import store from "../vuex/store";
import SIdentify from "@/common/identify";
import { swiper, swiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  name: "login",
  components: {
    SIdentify,
    Nvc,
    swiper,
    swiperSlide
  },
  store,
  data() {
    let validateName = (rule, value, callback) => {
      console.log(rule);
      if (value === "") {
        callback(new Error("请输入用户名/手机号码/编号"));
        this.accountForm.active1 = false;
        this.accountForm.activeclass1 = false;
      } else if (value.length < 3 || value.length > 40) {
        this.accountForm.activeclass1 = true;
        this.accountForm.active1 = false;
        callback(new Error("长度在 3 到 40 个字符"));
      } else {
        this.accountForm.active1 = true;
        callback();
      }
    };

    let validataLoginPass = (rule, value, callback) => {
      if (value === "") {
        this.accountForm.active2 = false;
        callback(new Error("请输入密码"));
      } else {
        this.accountForm.active2 = true;
        callback();
      }
    };
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));

        this.registerForm.activeclass3 = false;
      } else if (value.length < 6 || value.length > 12) {
        this.registerForm.activeclass3 = false;

        callback(new Error("密码长度只能为6-12位"));
      } else if (/[^\x00-\xff]+$/.test(value)) {
        this.registerForm.activeclass3 = false;

        callback(new Error("不能使用汉字或全角字符作为密码"));
      } else {
        callback();
      }
    };
    let validatecode = (rule, value, callback) => {
      //账号登录 验证码
      if (value == "") {
        this.accountForm.active3 = false;
        this.accountForm.activeclass2 = false;
        callback(new Error("请输入验证码"));
      } else if (value != this.identifyCode) {
        this.accountForm.active3 = false;
        callback(new Error("验证码错误"));
        this.refreshCode();
      } else {
        this.accountForm.active3 = true;
        callback();
      }
    };
    let phoneverify = (rule, value, callback) => {
      //手机号码登录 验证手机号码
      var reg = /^[1][3456789][0-9]{9}$/;
      if (value == "") {
        callback(new Error("请输入手机号"));
        this.phoneForm.active1 = true;
        this.phoneForm.activeclass1 = false;
      } else if (!reg.test(this.phoneForm.phone)) {
        this.phoneForm.active = true;
        callback(new Error("请输入正确手机号"));
      } else {
        this.phoneForm.active1 = false;
        callback();
      }
    };
    let phonecode = (rule, value, callback) => {
      //手机号码登录 验证 验证码
      if (value == "") {
        this.phoneForm.activeclass2 = false;
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    let regisphone = (rule, value, callback) => {
      //注册 验证手机号码
      var reg = /^[1][3456789][0-9]{9}$/;
      if (value == "") {
        callback(new Error("请输入手机号"));
        this.registerForm.activeclass1 = false;
      } else if (!reg.test(this.registerForm.phone)) {
        callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    let validateRegiscode = (rule, value, callback) => {
      //注册  验证码
      if (value == "") {
        this.registerForm.activeclass2 = false;
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    let validateRePass = (rule, value, callback) => {
      //注册  确认密码
      if (value === "") {
        callback(new Error("请再次输入密码"));
        this.registerForm.activeclass4 = false;
      } else if (value !== this.registerForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      activeShow: 0,
      loginShow: true,
      passtijiao: true,
      phonejiao: true,
      registijiao: true,
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
          pagination: {
            el: ".swiper-pagination",
            type: "custom",
            renderCustom: function(swiper, current, total) {
              console.log(swiper);
              var customPaginationHtml = "";
              let arrayInde = ["登录", "注册"];
              for (var i = 0; i < total; i++) {
                //判断哪个分页器此刻应该被激活
                if (i == current - 1) {
                  customPaginationHtml +=
                    '<span class="swiper-pagination-customs swiper-pagination-customs-active">1</span>';
                } else {
                  customPaginationHtml +=
                    '<span class="swiper-pagination-customs">2</span>';
                }
              }
              return '<span class="swiperPag">' + arrayInde[i] + "</span>";
            }
          }
        }
        // Some Swiper option/callback...
      },
      nvctype: "", //nvc场景
      codeLoading: false, //获取验证码
      codeLoadingreg: false, //注册验证码
      identifyCodes: "1234567890", //图片验证码
      identifyCode: "", //图片验证码
      loginCode: "",
      phoneCode: "",
      activeName: "second",
      stretch: true,
      loginFormVisible: true,
      registerFormVisible: false,
      showWeixin: false,
      qrcodeUrl: "",
      refresh_qrcode: false,
      boxVisible: true,
      t: "",
      // qrcodeTips："请使用微信扫描二维码",
      qrcodeTips:
        "<span class='el-icon-circle-check' style='color:#2BB906;font-size:24px;vertical-align:middle;margin-right:7px;'></span>扫描成功，正在登录……",
      accountForm: {
        name: "",
        password: "",
        qrcode: "",
        isShowPassword: false,
        activeclass1: false,
        activeclass2: false,
        activeclass3: false,
        active1: false,
        active2: false,
        active3: false
      },
      accountFormRules: {
        //账号登陆
        name: [
          // {
          //   required: true,
          //   message: "请输入用户名/手机号码/编号",
          //   trigger: "blur",
          // },
          // {
          //   min: 3,
          //   max: 40,
          //   message: "长度在 3 到 40 个字符",
          //   trigger: "blur",
          // },
          {
            validator: validateName,
            trigger: "blur"
          }
        ],
        password: [
          { required: true, validator: validataLoginPass, trigger: "blur" }
        ],
        qrcode: [{ validator: validatecode, trigger: "blur" }]
      },
      phoneForm: {
        phone: "",
        qrcode: "",
        isShowPassword: false,
        activeclass1: false,
        activeclass2: false,
        active1: true,
        active2: true
      },
      phoneFormRules: {
        //手机登陆
        phone: [{ validator: phoneverify, trigger: "blur" }],
        qrcode: [{ validator: phonecode, trigger: "blur" }]
      },
      registerForm: {
        phone: "",
        qrcode: "",
        password: "",
        rePassword: "",
        isShowPassword: false,
        activeclass1: false,
        activeclass2: false,
        activeclass3: false,
        activeclass4: false,
        active1: false,
        active2: false,
        active3: false,
        active4: false
      },
      registerFormRules: {
        //用户注册
        phone: [{ validator: regisphone, trigger: "blur" }],
        qrcode: [
          { required: true, validator: validateRegiscode, trigger: "blur" }
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        rePassword: [{ validator: validateRePass, trigger: "blur" }]
      },
      includeMalltype: ["lipinduihuan", "xfj"],
      malltype: window.location.host.split(".")[0]
    };
  },
  watch: {
    accountForm: {
      deep: true,
      handler: function(newVal, oldVal) {
        this.accountForm.password = this.accountForm.password.replace(
          /\s+/g,
          ""
        );
        console.log(newVal.active1);
        console.log(oldVal);
        let arr = [newVal.active1, newVal.active2, newVal.active3];
        console.log(arr);
        this.passtijiao = !arr.every(function(x) {
          return x === true;
        });

        console.log(this.passtijiao);
        // let arratActive=[this.this.accountForm.active1,this.this.accountForm.active2,this.this.accountForm.active3];
      }
    },
    registerForm: {
      deep: true,
      handler: function(newVal, oldVal) {
        this.registerForm.password = this.registerForm.password.replace(
          /\s+/g,
          ""
        );
      }
    },
    showWeixin(val) {
      if (!val) {
        clearInterval(this.t);
      }
    }
  },
  computed: {
    swiper() {
      console.log(this.$refs.mySwiper.$swiper);
      // return this.$refs.mySwiper.$swiper
    },
    isShwoLogin() {
      var str = window.location.host;
      var malltype = str.split(".")[0];
      return !this.includeMalltype.includes(malltype);
    }
  },
  methods: {
    tt() {
      console.log(1);
      // console.log(this.$refs.accountForm.$children);
      // let arraywei = this.$refs.accountForm.$children;
      // for (let i = 0; i <= arraywei.length; i++) {
      //   console.log(arraywei[i]);
      //   console.log(arraywei[i].$children);
      //   console.log(arraywei[i].$attrs);
      // }
    },
    onInputFocus() {
      console.log(this);
      this.accountForm.activeclass1 = true;
      console.log(this.accountForm.activeclass1);
      console.log(this.$attrs);
    },
    blur(value, index) {
      if (index == 0) {
        if (!value) {
          this.accountForm.activeclass1 = false;
        }
      }
      if (index == 1) {
        if (!value) {
          this.accountForm.activeclass2 = false;
        }
      }
      if (index == 2) {
        if (!value) {
          this.accountForm.activeclass3 = false;
        }
      }
    },
    slide(value) {
      // console.log(this.$refs.mySwiper.swiper.slideTo)
      this.$refs.mySwiper.swiper.slideTo(value);
      this.activeShow = value;
    },
    //账号登录获取nvc
    submitnvc: function(formName, type) {
      switch (type) {
        case 1:
          //账号密码登录
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.nvctype = "nvc_login";
              this.$refs.nverify.startVerify()
            } else {
              return false;
            }
          });
          break;
        case 2:
          //手机验证码 登陆
          var _this = this;
          var reg = /^[1][3456789][0-9]{9}$/;
          if (!reg.test(this.phoneForm.phone)) {
            this.$alert("手机号码不正确", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                _this.codeLoadingreg = false;
              }
            });
            return false;
          }
          if (this.phoneForm.phone == "") {
            return false;
          }
          this.nvctype = "nvc_message";
          this.$refs.nverify.startVerify()
          break;

        case 3:
        var _this = this;
          var reg1 = /^[1][3456789][0-9]{9}$/;
          if (!reg1.test(this.registerForm.phone)) {
            this.$alert("手机号码不正确", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                _this.codeLoadingreg = false;
              }
            });
            return false;
          }
          //验证 手机号是否为空
          if (this.registerForm.phone == "") {
            return false;
          }
          this.nvctype = "register_message";
          this.$refs.nverify.startVerify()
          break;
        default:
          break;
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    viewPassword(isShow) {
      return isShow ? "text" : "password";
    },
    changeVisible() {
      this.loginFormVisible = !this.loginFormVisible;
      this.registerFormVisible = !this.registerFormVisible;
    },
    //账号登录
    submitForm(captchaVerifyParam) {
      //验证 输入框信息
      // this.$refs[formName].validate((valid) => {
      // if (valid) {
      //请求登陆接口
      return new Promise((resolve, reject) => {
        this.$api.post(
          "user/login/login",
          {
            id_example: this.$store.state.id_example,
            type: 2,
            account: this.accountForm.name,
            password: this.accountForm.password,
            captchaVerifyParam
          },
          res => {
            if (res.data.code == "100") {
              this.$store.state.user_id = res.data.data.token_user;
              this.$store.commit("userInfo");
              this.$store.commit("cartnum");
              resolve(true)
              this.goPath();
            } else if (
              res.data.code == "400"
            ) {
              resolve(false)
            } else if (res.data.code == "800") {
            } else {
              resolve(true)
              this.refreshCode();
              this.$alert(res.data.message, "提示", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          }
        );
      })
      
      //   } else {
      //     return false;
      //   }
      // });
    },
    //生成验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //生成验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
        // console.log(this.identifyCode)
      }
    },
    //生成验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //获取手机登录验证码
    getCode(captchaVerifyParam) {
      //倒计时
      const _this = this
      return new Promise((resolve, reject) => {
        if (this.codeLoading == false) {
          this.codeLoading = true;
          this.$api.post(
            "/message",
            {
              id_example: this.$store.state.id_example,
              phone: this.phoneForm.phone,
              type: 2,
              captchaVerifyParam
            },
            res => {
              if (res.data.code == 100) {
                this.phoneCode = res.data.data;
                resolve(true)
                //短信发送成功开启倒计时
                var time = 60;
                var dd = setInterval(function() {
                  time--;
                  $(".phonecode").html("倒计时(" + time + ")秒");
                  if (time <= 0) {
                    clearInterval(dd);
                    _this.codeLoading = false;
                    $(".phonecode").html(
                      '<span class=\\"van-button__text\\">重新发送</span>'
                    );
                  }
                }, 1000);
              } else if (
                res.data.code == "400"
              ) {
                resolve(false)
                _this.codeLoading = false;
                resolve(false)
              } else if (res.data.code == "800") {
                resolve(true)
              } else {
                resolve(true)
                this.$alert(res.data.message, "提示", {
                  confirmButtonText: "确定",
                  callback: action => {
                    _this.codeLoading = false;
                  }
                });
              }
            }
          );
        }
      })
      
    },
    //手机号码登录
    phonelogin() {
      let formName = "phoneForm";
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.nvctype = "nvc_mobile_login";
          this.$refs.nverify.startVerify()
        }
      })
    },
    comit(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        //登录
        this.$api.post(
          "user/login/phone",
          {
            id_example: this.$store.state.id_example,
            type: 2,
            phone: this.phoneForm.phone,
            code: this.phoneCode + "_" + this.phoneForm.qrcode,
            captchaVerifyParam
          },
          res => {
            if (res.data.code == 100) {
              this.$store.state.user_id = res.data.data.token_user;
              this.$store.commit("userInfo");
              resolve(true)
              this.goPath();
            } else if (
              res.data.code == "400"
            ) {
              resolve(false)
              _this.codeLoading = false;
            } else if (res.data.code == "800") {
              resolve(true)
              _this.codeLoading = false;
            } else {
              resolve(true)
              this.refreshCode();
              this.$alert(res.data.message, "提示", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          }
        );
      })
    },
    //获取注册验证码
    registerCode(captchaVerifyParam) {
      //倒计时
      var _this = this;
      return new Promise((resolve, reject) => {
        if (this.codeLoadingreg == false) {
          this.codeLoadingreg = true;
          this.$api.post(
            "/message",
            {
              id_example: this.$store.state.id_example,
              phone: this.registerForm.phone,
              type: 1,
              captchaVerifyParam
            },
            res => {
              if (res.data.code == 100) {
                this.loginCode = res.data.data;
                //短信发送成功开启倒计时
                this.codeLoadingreg = true;
                var time = 60;
                var dd = setInterval(function() {
                  time--;
                  $(".loginCode").html("倒计时(" + time + ")秒");
                  if (time <= 0) {
                    clearInterval(dd);
                    _this.codeLoadingreg = false;
                    $(".loginCode ").html(
                      '<span class=\\"van-button__text\\">重新发送</span>'
                    );
                  }
                }, 1000);
                resolve(true)
              } else if (
                res.data.code == "400"
              ) {
                resolve(false)
                _this.codeLoadingreg = false;
              }else {
                resolve(true)
                this.$alert(res.data.message, "提示", {
                  confirmButtonText: "确定",
                  callback: action => {
                    _this.codeLoadingreg = false;
                  }
                });
              }
            }
          );
        }
      })
    },
    //注册账号
    RegisterNow(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.nvctype = "nvc_register";
          this.$refs.nverify.startVerify()
          //注册
        } else {
          return false;
        }
      });
    },
    comRegister(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        this.$api.get(
          "user/register",
          {
            id_example: this.$store.state.id_example,
            phone: this.registerForm.phone,
            password: this.registerForm.password,
            repassword: this.registerForm.password,
            captchaVerifyParam,
            verify: this.loginCode + "_" + this.registerForm.qrcode
          },
          res => {
            if (res.data.code == 100) {
              resolve(true)
              this.$confirm("注册成功", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                this.loginFormVisible = true;
                this.registerFormVisible = false;
              });
              this.$router.push({ name: "Login", params: { type: 1 } });
            }  else if(res.data.code == "400") {
              resolve(false)
            } else {
              resolve(true)
              this.$alert(res.data.message, "提示", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          }
        );
      })
      
    },
    //微信登录
    wexinLogin() {
      this.showWeixin = true;
      this.refresh_qrcode = false;
      this.qrcodeTips = "请使用微信扫描二维码";
      this.$api.get(
        "user/wechat/p_login",
        {
          id_example: this.$store.state.id_example
        },
        res => {
          if (res.data.code == 100) {
            let str = res.data.data.url.split("php?text=");
            var canvas = document.getElementById("canvas");
            QRCode.toCanvas(canvas, str[str.length - 1], function(error) {
              if (error) console.error(error);
              console.log("success!");
            });
            // this.qrcodeUrl = "http://"+res.data.data.url;
            var bind_id = res.data.data.bind_id;
            this.t = setInterval(() => {
              this.$api.post(
                "user/wechat/login2",
                {
                  id_example: this.$store.state.id_example,
                  id: bind_id
                },
                res => {
                  if (res.data.code == 100) {
                    clearInterval(this.t);
                    this.qrcodeTips =
                      "<span class='el-icon-circle-check' style='color:#2BB906;font-size:24px;vertical-align:middle;margin-right:7px;'></span>扫描成功，正在登录……";
                    setTimeout(() => {
                      this.showWeixin = false;
                      this.$store.state.user_id = res.data.data.token_user;
                      this.$store.commit("userInfo");
                      this.$store.commit("cartnum");
                      this.goPath();
                    }, 1000);
                  }
                }
              );
            }, 1000);
            setTimeout(() => {
              clearInterval(this.t);
              this.refresh_qrcode = true;
              this.qrcodeTips = "二维码已失效，点击重新获取";
            }, 600000);
          } else {
            this.$alert(res.data.msg, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        }
      );
    },
    //登录之后跳转
    goPath() {
      this.$message({
        message: "登录成功",
        duration: 2000,
        center: true
      });
      this.getAddress();
      if (this.$route.name != "Detail") {
        setTimeout(() => {
          this.$router.push({ name: "Home" });
        }, 200);
      } else {
        this.boxVisible = false;
        this.$emit("hide");
      }
    },
    watchkey() {
      var _this = this;
      $(document).keydown(function(event) {
        if (event.keyCode == 13) {
          _this.activeName == "first" ? _this.submitnvc("accountForm", 1) : "";
          _this.activeName == "second" ? _this.phonelogin("phoneForm") : "";
        }
      });
    },
    getAddress() {
      var _this = this;
      this.$api.get(
        "user/address/list",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id
        },
        res => {
          if (res.data.code == "100") {
            res.data.data.forEach(item => {
              if (item.default == 1) {
                var json = {
                  area: [
                    item.province_str,
                    item.city_str,
                    item.county_str,
                    item.town_str
                  ],
                  id: [
                    item.province,
                    item.city,
                    item.county,
                    item.town ? item.town : 0
                  ]
                };
                this.$store.commit("setAddress", json);
                localStorage.setItem(
                  "messageStore1",
                  JSON.stringify(this.$store.state)
                );
              }
            });
          }
        }
      );
    },
    verifyMethods(captchaVerifyParam) {
      return new Promise(async(resolve, reject) => {
        switch (this.nvctype) {
          case 'nvc_login':
            const data = await this.submitForm(captchaVerifyParam)
            resolve(data)
            break;
          case 'nvc_message':
            const dataMobile = await this.getCode(captchaVerifyParam)
            resolve(dataMobile)
            break;
          case 'nvc_mobile_login':
            const dataMobileLogin = await this.comit(captchaVerifyParam)
            resolve(dataMobileLogin)
            break;
          case 'register_message':
            const dataregisterMsg = await this.registerCode(captchaVerifyParam)
            resolve(dataregisterMsg)
            break;
          case 'nvc_register':
            const dataComRegister = await this.comRegister(captchaVerifyParam)
            resolve(dataComRegister)
            break;
         
        }
        
      })
    }
  },
  mounted() {
    this.tt();
    this.$route.params.type == 0 && $store.state.webInfo.register_status == 1
      ? this.changeVisible()
      : ""; //判断登录还是注册
    this.refreshCode(); //生成验证码
    this.watchkey(); //监听键盘回车键
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)

    var str = window.location.host;
    var malltype = str.split(".")[0];
    if (this.includeMalltype.includes(malltype)) {
      this.loginShow = false;
    }
  }
};
</script>

<style lang="less">
.el-dialog__header {
  background: #f5f5f5;
  border-radius: 6px 6px 0px 0px;
  padding: 15px 20px 15px 20px;
}
.is-disabled {
  opacity: 0.5;
}
.phonecode {
  width: 100px;
  position: absolute;
  right: 0px;
  top: 0px;
  height: 60px;
  background: none !important;
  border: none !important;
  color: #e23130;
}
.el-button:focus,
.el-button:hover {
  background: rgba(226, 49, 48, 0.9);
}
.loginCode {
  width: 100px;
  position: absolute;
  right: 0px;
  top: 0px;
  height: 60px;
  background: none !important;
  border: none !important;
  color: #e23130;
}
.login-register {
  .phonecode :hover,
  .phonecode :focus,
  .phonecode :active {
    color: #e23130 !important;
  }
  .loginform {
    width: 100% !important;
  }
  .g-bottom {
    height: 48px;
    background: rgba(226, 49, 48, 1) !important ;
    border-radius: 6px;
    border: 1px solid rgba(226, 49, 48, 1) !important ;
    &:hover {
      background: rgba(226, 49, 48, 0.9) !important ;
      border-radius: 6px;
      border: 1px solid rgba(226, 49, 48, 0.9) !important ;
    }
  }
  .g-bottom1 {
    opacity: 0.5;
  }
  .el-form-item.is-success .el-input__inner {
    border: 1px solid #f2f2f2;
    color: #262626;
    font-size: 14px;
  }
  .el-form-item.is-error .el-input__inner,
  .el-form-item.is-error .el-input__inner:focus,
  .el-form-item.is-error .el-textarea__inner,
  .el-form-item.is-error .el-textarea__inner:focus,
  .el-message-box__input input.invalid,
  .el-message-box__input input.invalid:focus {
    border-color: #fdf4f4;
    background: #fdf4f4;
  }
  .el-form-item.is-error .lableInput {
    color: #e23130 !important;
  }
  .swiper {
    width: 100%;
    // height: 200px;
  }
  .app-container {
    padding: 16px 35px;
    height: 520px;
    .swiperTitle {
      text-align: left;
      margin-bottom: 23px;

      span {
        position: relative;
        font-size: 16px;
        display: inline-block;
        color: rgba(38, 38, 38, 0.5);
        line-height: 24px;
        margin-right: 30px;
        padding-bottom: 5px;
      }
      .active {
        color: #262626;
      }
      .active::after {
        display: inline-block;
        content: "";
        width: 100%;
        height: 4px;
        border-radius: 3px;
        background: #e23130;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
  }
  .swiper-container {
    width: 100%;
  }

  .swiper-container .swiper-slide {
    width: 100%;
    height: 490px;
    // height: 200px;
    // overflow: hidden;
    /* padding-bottom: 100%; */
    border-radius: 6px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    // -webkit-box-pack: center;
    // -ms-flex-pack: center;
    // -webkit-justify-content: center;
    // justify-content: center;
    // -webkit-box-align: center;
    // -ms-flex-align: center;
    // -webkit-align-items: center;
    // align-items: center;
  }
  .swiper-container .swiper-slide img {
    width: 100%;
  }
  ::v-deep .swiper-pagination-fraction,
  .swiper-pagination-custom,
  ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 10px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* height: 40px; */
  }
  ::v-deep .swiper-container .swiper-pagination .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background: #fff;
    opacity: 0.4 !important;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
    margin-right: 0px;
  }
  ::v-deep
    .swiper-container
    .swiper-pagination
    .swiper-pagination-bullet-active {
    background-color: #fff;
    opacity: 1 !important;
    width: 16px;
    border-radius: 4px;
  }
  width: 424px;
  // background: url("/static/img/login_register_bg.png") no-repeat;
  background-size: 100%;
  background-color: white;
  .qrcode-img {
    display: inline-block;
    margin-left: 12px;
    width: 128px;
    height: 40px;
    box-sizing: border-box;
    position: absolute;
    right: 0px;
    top: 12px;
    // border: 1px solid black;
  }
  .quick-text {
    clear: both;
    margin-top: 26px;
    & > div {
      display: inline-block;
    }
  }
  .line {
    width: 105px;
    height: 1px;
    background-color: #979797;
    margin-bottom: 3px;
  }
  .el-form-item {
    margin-bottom: 0px;
    position: relative;
    // padding-bottom: 22px;
    margin-bottom: 15px;
  }
  .el-form-item__content {
    display: flex;
    display: flex;
    flex-direction: column;
  }
  .el-form-item__error {
    padding-top: 10px;
    text-align: left;
    position: relative;
    font-size: 13px;
    line-height: 17px;
  }
  .el-tabs__item {
    font-size: 14px;
    font-weight: bold;
  }
  .el-form-item__label {
    position: absolute;
    top: 17px;
    left: 22px;
    z-index: 99;
    height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(38, 38, 38, 0.5);
    line-height: 24px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: text;
    display: inline-block;
    width: 340px !important;
    text-align: left;
  }
  .el-input__inner {
    height: 60px;
    //  line-height: 60px;
    background: #f2f2f2;
    border-radius: 3px;
    border: solid 1px #f2f2f2;

    padding: 30px 20px 10px;
  }
  .lableInput {
    position: absolute;
    top: 17px;
    left: 22px;
    z-index: 99;
    height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(38, 38, 38, 0.5);
    line-height: 24px;
    user-select: none;
    cursor: text;
  }
  .lableInput1 {
    font-size: 12px;
    top: 5px;
    transition: top 0.15s cubic-bezier(0.4, 0, 0.2, 1),
      font-size 0.15s cubic-bezier(0.4, 0, 0.2, 1),
      color 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .lableInput2 {
    color: #e23130;
  }
  .el-form-item.is-error .el-input__inner:focus {
    border: solid 1px #e23130;
    background: #fff;
    box-shadow: 0px 4px 7px 0px rgba(255, 210, 210, 0.6);
  }
  .el-input__inner:focus {
    border: solid 1px #e23130;
    background: #fff;
    box-shadow: 0px 4px 7px 0px rgba(255, 210, 210, 0.6);
  }
  #pane-second {
    padding: 0 37px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/login.vue